import { Surfaces } from "@netlify/sdk--ui-core";
import React from "react";
import { useNetlifySDK } from "../../use_netlify_sdk.js";

export type TeamConfigurationSurfaceProps = {
  /**
   * Content to render within the element.
   */
  children?: React.ReactNode | undefined;

  /**
   * A class property to attach to the element.
   *
   * @see {@link !Element.className}
   */
  className?: string | undefined;
};

/**
 * A container element used to render the Team Configuration surface. This component will take care
 * of styling your component so it looks good on your extension’s details page in the Netlify UI,
 * under **Extensions > [your extension’s details page] > Configuration**.
 *
 * <!-- TODO(ndhoule): Add a screenshot here -->
 *
 * @param props
 * @see Surfaces.TeamConfiguration
 * @example
 * ```tsx
 * import { TeamConfigurationSurface } from "@netlify/sdk/react/components";
 *
 * <TeamConfigurationSurface>
 *   <div>Your surface content goes here</div>
 * </TeamConfigurationSurface>
 * ```
 */
export const TeamConfigurationSurface = ({
  className,
  children,
  ...otherProps
}: TeamConfigurationSurfaceProps) => {
  const sdk = useNetlifySDK();

  return (
    <>
      <section
        id={`section-${Surfaces.TeamConfiguration}-${sdk.extension.slug}`}
        className={className}
        {...otherProps}
      >
        {children}
      </section>
    </>
  );
};
